export const COMPONENTS = {
  CURRENCY: "CurrencyValue",
  NUMBER: "NumberValue"
};
export class Element {
  key;
  value;
  constructor(key, value) {
    this.key = key;
    this.value = value;
  }
}
export class Kpi extends Element {
  scope;
  component;
  constructor(key, value, scope = [], component) {
    super(key, value);
    this.scope = scope;
    this.component = component;
  }
}
export class EvolutionSplit {
  element;
  evolution = null;
  constructor(element, evolution) {
    this.element = element;
    this.evolution = evolution;
  }
  initialize(root, item) {
    this.evolution = item[`${root}_${this?.element?.key}`];
  }
}
export class EvolutionCard {
  type;
  value = null;
  splits = [];
  constructor(type, value, splits) {
    this.type = type;
    this.value = value;
    this.splits = splits;
  }
  initialize(root, item) {
    this.value = item[`${root}_${this.type.key}`];
    this.splits.forEach(s => s.initialize(`${root}_${this?.type?.key}`, item));
  }
}
export class PeriodKpi {
  kpi;
  cards = [];
  constructor(kpi, cards) {
    this.kpi = kpi;
    this.cards = cards;
  }
}
export const createCurrentPeriodViewFromData = (item, considredKpis) => {
  if (!item) {
    console.error("No data was returned");
    return;
  }
  let map = {};
  for (const [tab, element] of Object.entries(considredKpis)) {
    element.scope.forEach(s => {
      s.initialize(element.key, item);
    });
    map[tab] = element;
  }
};
const EVOLUTION_TYPES = {
  PREVIOUS: "evolution",
  LAST_YEAR: "last_year_evolution"
};
export const SCOPES = {
  YESTERDAY: () => new EvolutionCard(new Element("yesterday", "Yesterday"), null, [new EvolutionSplit(new Element(EVOLUTION_TYPES.PREVIOUS, "Same day LW"), null), new EvolutionSplit(new Element(EVOLUTION_TYPES.LAST_YEAR, "Same day LY"), null)]),
  WTD: () => new EvolutionCard(new Element("wtd", "Week to date"), null, [new EvolutionSplit(new Element(EVOLUTION_TYPES.PREVIOUS, "Previous WTD"), null), new EvolutionSplit(new Element(EVOLUTION_TYPES.LAST_YEAR, "Same period LY"), null)]),
  MTD: () => new EvolutionCard(new Element("mtd", "Month to date"), null, [new EvolutionSplit(new Element(EVOLUTION_TYPES.PREVIOUS, "Previous MTD"), null), new EvolutionSplit(new Element(EVOLUTION_TYPES.LAST_YEAR, "Same period LY"), null)]),
  YTD: () => new EvolutionCard(new Element("ytd", "Year to date"), null, [new EvolutionSplit(new Element(EVOLUTION_TYPES.PREVIOUS, "Previous YTD"), null)])
};
export const DEFAULT_SCOPES = () => [SCOPES.YESTERDAY(), SCOPES.WTD(), SCOPES.MTD(), SCOPES.YTD()];